$('.block-tabbed-content').each(function() {

    const mobile_nav_buttons = $(this).find('.tab-button--mobile');
    const desktop_nav_buttons = $(this).find('.tab-button--desktop');
    const tabs = $(this).find('.block-tabbed-content-item');
    
    // Activate first on page load
    tabs.first().addClass('is-active');
    
    mobile_nav_buttons.on('click', function() {

        var tab = $(this).closest('.block-tabbed-content-item');

        if (tab.hasClass('is-active')) {
            tabs.removeClass('is-active');
        } else {
            tabs.removeClass('is-active');
            tab.addClass('is-active');
        }
        
    });

    desktop_nav_buttons.on('click', function() {

        var tab_index = $(this).data('tab');
        
        desktop_nav_buttons.removeClass('is-active');
        $(this).addClass('is-active');

        tabs.removeClass('is-active');
        tabs.eq(tab_index).addClass('is-active');

    });

});